import { Api } from "./Api";

export default {
    show(id = "") {
        return Api.get("/v1/tags" + id);
    },
    store(name, type) {
        return Api.post(`/v1/tags?name=${name}&type=${type}`);
    },
    remove(id) {
        return Api.delete("/v1/tags/" + id);
    },
    update(name, id) {
        return Api.put(`/v1/tags/${id}?name=${name}`);
    }
}